import styled from 'styled-components';
import {
  Container,
  Navbar as NavbarBootstrap,
  NavLink as NavLinkBootstrap,
  Nav as NavBootstrap,
  DropdownToggle as DropdownToggleBootstrap,
  DropdownItem as DropdownItemBootstrap,
  DropdownMenu as DropdownMenuBootrap,
  Dropdown as DropdownBootrap,
  Collapse as CollapseBootstrap,
} from 'reactstrap';

import colors from '../../includes/colors';

export const Navbar = styled(NavbarBootstrap)`
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.25);
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
`;

export const HeaderPilot = styled.header`
  max-height: 66px;
  position: relative;
  z-index: 5;
  .navbar {
    height: 66px;
  }
  .navbar-brand {
    padding-right: 25px;
    position: relative;
    @media (max-width: 400px) {
      max-width: 50%;
    }

    img {
      max-height: 55px;
      width: 140px;
    }
    &:after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -15px;
      height: 30px;
      width: 1px;
      border-left: solid 1px #ccc;
      display: none;
      @media (min-width: 992px) {
        display: inline-block;
      }
    }
  }
  .nav-item {
    .nav-link {
      color: ${colors.blue} !important;
    }
  }
  .nav-item {
    &:hover {
      .nav-link {
        background: ${colors.white};
        color: ${colors.blue};
      }
    }
  }
`;

export const Toggler = styled.button`
  border: none;
  .dds__icons {
    color: ${colors.blue};
    @media (min-width: 768px) {
      display: inline-block;
    }
  }
  span {
    color: ${colors.blue};
    font-size: 0.875rem;
    display: inline-block;
    @media (min-width: 768px) {
      display: inline-block;
      transform: translate(5px, -6px);
    }
  }
`;

export const Teardrop = styled.div`
  @media (max-width: 992px) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    opacity: 0;
    transition: opacity.25s ease;
    transform: scale(0);
    z-index: -1;
    &.show {
      z-index: 9997;
      opacity: 1;
      transform: scale(1);
    }
  }
`;

export const ChevronIcon = styled.span`
  color: ${colors.blue};
  display: inline-block;
  font-size: 0.875rem;
  margin-left: 6px;
  position: relative;
  top: 2px;
  @media (max-width: 991px) {
    display: none;
  }
`

export const Logo = styled.img`
  font-size: 1rem;
  color: white;
  font-weight: 300;
  @media (min-width: 768px) {
    transform: none;
  }
`;

export const ContainerBox = styled(Container)`
  flex-wrap: nowrap !important;
`;

export const Dropdown = styled(DropdownBootrap)`
  & .dropdown-item:not(:last-child) {
    border-bottom: 0.0625rem solid #aaa;
  }
`;

export const NavLink = styled(NavLinkBootstrap)`
  font-size: 0.875rem;
  background: none !important;
  padding: 0;
`;

export const DropdownToggle = styled(DropdownToggleBootstrap)`
  font-size: 1rem;
  padding: 0.6rem 1.2rem !important;
  border: none;
  background: none;

  &:after {
    content: '〉';
    border: none;
    right: 1rem;
    position: absolute;
    font-family: dds-icons;
    transform: rotate(90deg);
  }

  &[aria-expanded='true'] {
    &:after {
      transform: rotate(-90deg);
    }
  }

  @media (min-width: 992px) {
    margin-left: 15px;
    font-size: 0.875rem;

    &:after {
      content: none;
    }
  }
`;

export const DropdownItem = styled(DropdownItemBootstrap)`
  padding: 0.5rem 0.9rem;

  &:active {
    background-color: #f8f9fa;
  }

  &:hover,
  &:focus {
    background-color: #f8f9fa !important;
  }

  @media (min-width: 992px) {
    border-bottom: 0 !important;
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
    padding-left: 1.3rem !important;
    padding-right: 1.3rem !important;
  }
`;

export const DropdownMenu = styled(DropdownMenuBootrap)`
  border-bottom: none;
  position: relative !important;
  padding-left: 2rem;

  @media (min-width: 992px) {
    border-bottom: 0.1875rem solid rgb(0, 125, 184);
    transform: translateY(-1px);
    position: absolute !important;
    padding-left: 0;
    left: 8px;
  }
`;

export const Nav = styled(NavBootstrap)`
  & .dropdown {
    border-top: 0.0625rem solid #aaa;
  }

  & .dropdown:last-child {
    border-bottom: 0.0625rem solid #aaa;
  }

  @media (min-width: 992px) {
    & .dropdown {
      border-top: 0;
      border-bottom: 0 !important;
    }
  }
`;
export const Collapse = styled(CollapseBootstrap)`
  @media (max-width: 991px) {
    &.show {
      .dropdown-menu {
        transform: none !important;
      }
    }
  }
`;
